/* YuGiSbusta theme scripts */
(function () {
  'use strict';

  // Mobile menu
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.getElementById(btn.getAttribute('aria-controls'));
      if (!nav) return;
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Buy forms: sealed / live mode toggle, nickname, price
  function setupBuyForm(form) {
    var idInput = form.querySelector('[data-variant-input]');
    var buttons = form.querySelectorAll('.mode-btn');
    var select = form.querySelector('[data-variant-select]');
    var nickWrap = form.querySelector('[data-nick]');
    var nickInput = nickWrap ? nickWrap.querySelector('input') : null;
    var noteEl = form.querySelector('[data-note]');
    var priceEl = form.querySelector('[data-price-display]');
    var addBtn = form.querySelector('[data-add]');
    var addLabel = addBtn ? addBtn.getAttribute('data-label') : '';
    var noteSealed = form.getAttribute('data-note-sealed') || '';
    var noteLive = form.getAttribute('data-note-live') || '';

    function apply(src) {
      if (!src) return;
      var live = src.getAttribute('data-live') === 'true';
      var available = src.getAttribute('data-available') !== 'false';
      if (idInput) idInput.value = src.getAttribute('data-variant-id');
      if (nickWrap) {
        nickWrap.classList.toggle('is-visible', live);
        if (nickInput) {
          nickInput.required = live;
          nickInput.disabled = !live;
        }
      }
      if (noteEl) noteEl.textContent = live ? noteLive : noteSealed;
      if (priceEl && src.getAttribute('data-price')) {
        var html = src.getAttribute('data-price');
        var compare = src.getAttribute('data-compare');
        priceEl.innerHTML = '';
        priceEl.appendChild(document.createTextNode(html));
        if (compare) {
          var s = document.createElement('s');
          s.textContent = compare;
          priceEl.appendChild(s);
        }
      }
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? addLabel : 'Esaurito';
      }
      var root = form.closest('[data-product-root]');
      if (root && src.getAttribute('data-image')) {
        var main = root.querySelector('[data-main-image]');
        if (main) {
          main.src = src.getAttribute('data-image');
          main.removeAttribute('srcset');
        }
      }
      if (form.hasAttribute('data-update-url') && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', src.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', url.toString());
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        apply(btn);
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        apply(select.options[select.selectedIndex]);
      });
      apply(select.options[select.selectedIndex]);
    } else {
      var pressed = form.querySelector('.mode-btn[aria-pressed="true"]');
      if (pressed) apply(pressed);
    }

    form.addEventListener('submit', function (e) {
      if (nickInput && nickInput.required) {
        nickInput.value = nickInput.value.trim().replace(/^@+/, '');
        if (!nickInput.value) {
          e.preventDefault();
          nickInput.focus();
          nickInput.setCustomValidity('Scrivi il tuo nickname TikTok, così ti chiamiamo in live.');
          nickInput.reportValidity();
          return;
        }
        nickInput.value = '@' + nickInput.value;
      }
    });
    if (nickInput) {
      nickInput.addEventListener('input', function () { nickInput.setCustomValidity(''); });
    }
  }
  document.querySelectorAll('[data-buy-form]').forEach(setupBuyForm);

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        var min = parseInt(input.getAttribute('min') || '0', 10);
        v = Math.max(min, v + parseInt(b.getAttribute('data-step'), 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var root = t.closest('[data-product-root]');
      var main = root && root.querySelector('[data-main-image]');
      if (!main) return;
      main.src = t.getAttribute('data-thumb');
      main.removeAttribute('srcset');
      root.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  // Collection sort
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
